/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SelectZone.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { componentStyle } from "../../../../config/appTheme";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CustomPaginationV2 from "../../../../components/customComponentsV2/common/pagination/CustomPaginationV2";

function SelectZone({ zoneList = [], selectedZone, getChangedZone }) {
  return (
    <Box>
      <Box component={Paper} elevation={2}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            borderRadius: 0,
            height: "300px",
            overflow: "auto",
          }}
        >
          {zoneList?.map((zone) => (
            <Grid
              container
              key={zone.position ?? zone.zone_name}
              sx={{
                ":hover": {
                  backgroundColor: "#D5D5D5",
                  cursor: "pointer",
                },

                backgroundColor:
                  zone.position === selectedZone ? "#D5D5D5" : "#ffffff",
              }}
              onClick={() => {
                getChangedZone(zone.position, zone.zone_name);
              }}
            >
              <Grid
                item
                sm={11}
                sx={{
                  alignItems: "center",
                  p: 1,
                }}
              >
                <Typography sx={{ ...componentStyle.font.text }}>
                  {zone.zone_name}
                </Typography>
              </Grid>
              <Grid item sm={1}>
                <ChevronRightIcon />
              </Grid>
            </Grid>
          ))}
        </Box>
        <CustomPaginationV2 page={1} rowsPerPage={25} totalItems={25} />
      </Box>
    </Box>
  );
}

SelectZone.propTypes = {
  zoneList: PropTypes.arrayOf(
    PropTypes.shape({
      position: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      zone_name: PropTypes.string,
    }),
  ),
  selectedZone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  getChangedZone: PropTypes.func,
};

SelectZone.defaultProps = {
  zoneList: [],
  selectedZone: null,
  getChangedZone: () => {},
};

export default SelectZone;
